// THIS FILE IS GENERATED AUTOMATICALLY DURING BUILD
// SHOULD NOT BE EDITED MANUALLY
import { version } from '../../../../../package.json';
export const versionInfo = {
  buildTime:'2026-04-02T12:43:05+02:00',
  gitHash:'549df06bb',
  branchName:'develop-v2',
  tag:'v1.4.54',
  version:version
};
